import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PatientListComponent } from '../patient-list/patient-list.component';
import { FullLayoutComponent } from '../full-layout/full-layout.component';
import { LoginComponent } from '../login/login.component';
import { PageNotFoundComponent } from '../page-not-found/page-not-found.component';
import { AuthGuard } from '../services/auth-guard.service';
import { NextExaminationListComponent } from '../next-examination-list/next-examination-list.component';
import { InvoiceComponent } from '../invoice/invoice.component';

const appRoutes: Routes = [
  {
    path: '',
    component: FullLayoutComponent,
    children: [
      { path: 'aptitude_files', component: PatientListComponent, canActivate: [AuthGuard]},
      { path: 'next_examinations', component: NextExaminationListComponent, canActivate: [AuthGuard]},
      { path: 'invoice', component: InvoiceComponent, canActivate: [AuthGuard]},
      { path: '', redirectTo: 'aptitude_files', pathMatch: 'full', canActivate: [AuthGuard] }
    ]
  },
  { path: 'login', component: LoginComponent },

  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      enableTracing: false,
      useHash: true
    })
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/app-routing/app-routing.module.ts